<ng-template #entryUnavailable>
  <td>{{'parkingBooking.unavailable' | translate}}</td>
</ng-template>

<ng-template #noCredentials>
  <div class="modal-body">
    <h6>
      {{'parkingBooking.travisUnauthorized' | translate}}
      <a [href]="'https://www.yourtravis.com/pricing'" target="_blank">Pricing - TRAVIS</a>
    </h6>
    <p>
      {{'parkingBooking.travisContact' | translate}}
      <a [href]="'mailto:info@yourtravis.com'">info@yourtravis.com</a>
    </p>
  </div>
</ng-template>

<div class="modal-header">
  <h4 class="modal-title">{{'parkingBooking.form.title' | translate}}</h4>
  <button type="button" class="close" aria-label="Close" (click)="closeModal()">
    <i class="ico-close sz-xs"></i>
  </button>
</div>

<ng-container *ngIf="hasCredentials; else noCredentials">
<div class="modal-body">
  <div *ngIf="parkingInfo && bookingInfo == null">
    <h6 class="parking-name">{{parkingInfo.name}}</h6>
    <section>
      <strong>{{'parkingBooking.form.fees' | translate}}</strong>
      <div class="table-responsive simple-data-table">
        <table class="table table-bordered table-hover">
          <thead>
          <tr>
            <th>{{'parkingBooking.duration' | translate}}</th>
            <ng-container *ngFor="let price of parkingInfo.parking.prices">
              <th>{{price.duration + ('unit.h' | translate)}}</th>
            </ng-container>
          </tr>
          </thead>
          <tbody>
          <tr>
            <th>{{'parkingBooking.price' | translate}}</th>
            <ng-container *ngFor="let price of parkingInfo.parking.prices">
              <td>{{price.price + ' ' + parkingInfo.parking.currency}}</td>
            </ng-container>
          </tr>
          </tbody>
        </table>
      </div>
    </section>
    <section>
      <strong>{{'parkingBooking.entryHours' | translate}}</strong>
      <div class="table-responsive simple-data-table">
        <table appResponsiveTable class="table table-bordered table-hover">
          <thead>
          <tr>
            <th></th>
            <th>{{'tacho.weekday.MONDAY' | translate}}</th>
            <th>{{'tacho.weekday.TUESDAY' | translate}}</th>
            <th>{{'tacho.weekday.WEDNESDAY' | translate}}</th>
            <th>{{'tacho.weekday.THURSDAY' | translate}}</th>
            <th>{{'tacho.weekday.FRIDAY' | translate}}</th>
            <th>{{'tacho.weekday.SATURDAY' | translate}}</th>
            <th>{{'tacho.weekday.SUNDAY' | translate}}</th>
          </tr>
          </thead>
          <tbody>
          <tr>
            <th>{{'parkingBooking.arrival' | translate}}</th>
            <ng-container *ngIf="isOpen247(parkingInfo.parking.openingHours.entry); else entryTable">
              <td colspan="7" class="text-center">{{'parkingBooking.open247' | translate}}</td>
            </ng-container>
            <ng-template #entryTable>
              <td *ngIf="parkingInfo.parking.openingHours.entry.monday.length > 0; else entryUnavailable">
                <ng-container *ngFor="let monday of parkingInfo.parking.openingHours.entry.monday; let last=last">
                  {{monday.from + '-' + monday.to}}{{!last ? ' / ' : ''}}
                </ng-container>
              </td>
              <td *ngIf="parkingInfo.parking.openingHours.entry.tuesday.length > 0; else entryUnavailable">
                <ng-container *ngFor="let tuesday of parkingInfo.parking.openingHours.entry.tuesday; let last=last">
                  {{tuesday.from + '-' + tuesday.to}}{{!last ? '/' : ''}}
                </ng-container>
              </td>
              <td *ngIf="parkingInfo.parking.openingHours.entry.wednesday.length > 0; else entryUnavailable">
                <ng-container
                  *ngFor="let wednesday of parkingInfo.parking.openingHours.entry.wednesday; let last=last">
                  {{wednesday.from + '-' + wednesday.to}}{{!last ? '/' : ''}}
                </ng-container>
              </td>
              <td *ngIf="parkingInfo.parking.openingHours.entry.thursday.length > 0; else entryUnavailable">
                <ng-container *ngFor="let thursday of parkingInfo.parking.openingHours.entry.thursday; let last=last">
                  {{thursday.from + '-' + thursday.to}}{{!last ? '/' : ''}}
                </ng-container>
              </td>
              <td *ngIf="parkingInfo.parking.openingHours.entry.friday.length > 0; else entryUnavailable">
                <ng-container *ngFor="let friday of parkingInfo.parking.openingHours.entry.friday; let last=last">
                  {{friday.from + '-' + friday.to}}{{!last ? '/' : ''}}
                </ng-container>
              </td>
              <td *ngIf="parkingInfo.parking.openingHours.entry.saturday.length > 0; else entryUnavailable">
                <ng-container *ngFor="let saturday of parkingInfo.parking.openingHours.entry.saturday; let last=last">
                  {{saturday.from + '-' + saturday.to}}{{!last ? '/' : ''}}
                </ng-container>
              </td>
              <td *ngIf="parkingInfo.parking.openingHours.entry.sunday.length > 0; else entryUnavailable">
                <ng-container *ngFor="let sunday of parkingInfo.parking.openingHours.entry.sunday; let last=last">
                  {{sunday.from + '-' + sunday.to}}{{!last ? '/' : ''}}
                </ng-container>
              </td>
            </ng-template>
          </tr>
          <tr>
            <th>{{'parkingBooking.departure' | translate}}</th>
            <ng-container *ngIf="isOpen247(parkingInfo.parking.openingHours.exit); else exitTable">
              <td colspan="7" class="text-center">{{'parkingBooking.open247' | translate}}</td>
            </ng-container>
            <ng-template #exitTable>
              <td *ngIf="parkingInfo.parking.openingHours.exit.monday.length > 0; else entryUnavailable">
                <ng-container *ngFor="let monday of parkingInfo.parking.openingHours.exit.monday; let last=last">
                  {{monday.from + '-' + monday.to}}{{!last ? '/' : ''}}
                </ng-container>
              </td>
              <td *ngIf="parkingInfo.parking.openingHours.exit.tuesday.length > 0; else entryUnavailable">
                <ng-container *ngFor="let tuesday of parkingInfo.parking.openingHours.exit.tuesday; let last=last">
                  {{tuesday.from + '-' + tuesday.to}}{{!last ? '/' : ''}}
                </ng-container>
              </td>
              <td *ngIf="parkingInfo.parking.openingHours.exit.wednesday.length > 0; else entryUnavailable">
                <ng-container
                  *ngFor="let wednesday of parkingInfo.parking.openingHours.exit.wednesday; let last=last">
                  {{wednesday.from + '-' + wednesday.to}}{{!last ? '/' : ''}}
                </ng-container>
              </td>
              <td *ngIf="parkingInfo.parking.openingHours.exit.thursday.length > 0; else entryUnavailable">
                <ng-container *ngFor="let thursday of parkingInfo.parking.openingHours.exit.thursday; let last=last">
                  {{thursday.from + '-' + thursday.to}}{{!last ? '/' : ''}}
                </ng-container>
              </td>
              <td *ngIf="parkingInfo.parking.openingHours.exit.friday.length > 0; else entryUnavailable">
                <ng-container *ngFor="let friday of parkingInfo.parking.openingHours.exit.friday; let last=last">
                  {{friday.from + '-' + friday.to}}{{!last ? '/' : ''}}
                </ng-container>
              </td>
              <td *ngIf="parkingInfo.parking.openingHours.exit.saturday.length > 0; else entryUnavailable">
                <ng-container *ngFor="let saturday of parkingInfo.parking.openingHours.exit.saturday; let last=last">
                  {{saturday.from + '-' + saturday.to}}{{!last ? '/' : ''}}
                </ng-container>
              </td>
              <td *ngIf="parkingInfo.parking.openingHours.exit.sunday.length > 0; else entryUnavailable">
                <ng-container *ngFor="let sunday of parkingInfo.parking.openingHours.exit.sunday; let last=last">
                  {{sunday.from + '-' + sunday.to}}{{!last ? '/' : ''}}
                </ng-container>
              </td>
            </ng-template>
          </tr>
          </tbody>
        </table>
      </div>
    </section>
    <hr/>
  </div>
  <form *ngIf="bookingForm && bookingInfo == null && (!isFreezer || freezersAllowed)" [formGroup]="bookingForm" class="booking-form">
    <section class="form__columns fc-3">
      <div class="form-group fc_c--required">
        <label for="startDate">{{'parkingBooking.form.start' | translate}}</label>
        <app-date-time-picker id="startDate"
                              [pickerType]="'DATE_TIME'"
                              [placement]="'bottom'"
                              [minDate]="minDate"
                              [form]="bookingForm"
                              [controlName]="'startDate'"
                              (dateValueChanged)="datePicked('startDate')">
        </app-date-time-picker>
        <app-control-messages [control]="bookingForm.controls.startDate"></app-control-messages>
      </div>
      <div class="form-group hour-select text-center fc_c--labelless">
        <div class="switch">
          <ng-container *ngFor="let hour of defaultHours">
            <a  class="switch__item" (click)="setEnd(hour)" tabindex="1">{{hour}}</a>
          </ng-container>
        </div>
      </div>
      <div class="form-group fc_c--required">
        <label for="endDate">{{'parkingBooking.form.end' | translate}}</label>
        <app-date-time-picker id="endDate"
                              [pickerType]="'DATE_TIME'"
                              [placement]="'bottom'"
                              [minDate]="minDate"
                              [form]="bookingForm"
                              [controlName]="'endDate'"
                              (dateValueChanged)="datePicked('endDate')">
        </app-date-time-picker>
        <app-control-messages [control]="bookingForm.controls.endDate"></app-control-messages>
      </div>
      <div class="form-group fc_c--required">
        <label for="driverName">{{'parkingBooking.form.driverName' | translate}}</label>
        <input maxlength="255" formControlName="driverName" type="text" class="form-control" id="driverName">
        <app-control-messages [control]="bookingForm.controls.driverName"></app-control-messages>
      </div>
      <div class="form-group fc_c--required">
        <label for="licensePlate">{{'parkingBooking.form.licensePlate' | translate}}</label>
        <input maxlength="255" formControlName="licensePlate" type="text" class="form-control" id="licensePlate">
        <app-control-messages [control]="bookingForm.controls.licensePlate"></app-control-messages>
      </div>
      <div class="form-group">
        <label for="trailerLicensePlate">{{'parkingBooking.form.trailerLicensePlate' | translate}}</label>
        <input maxlength="255" formControlName="trailerLicensePlate" type="text" class="form-control" id="trailerLicensePlate">
        <app-control-messages [control]="bookingForm.controls.trailerLicensePlate"></app-control-messages>
      </div>
    </section>
    <div *ngIf="parkingAvailability">
      <hr/>
      <div>
        {{'parkingBooking.form.availableSpots' | translate}}
        <strong>{{parkingAvailability.availableSpots}}
        <i [class]="parkingAvailability.available ? 'ico-check-square c-green' : 'ico-cross-square c-red'"></i></strong>
      </div>
      <div *ngIf="parkingAvailability.price">
        {{'parkingBooking.form.totalAmount' | translate}}
        <strong>{{parkingAvailability.price.amount + ' ' + parkingAvailability.price.currency}}</strong>
      </div>
    </div>
  </form>
  <ng-container *ngIf="isFreezer && !freezersAllowed">
    <div >
      <h5>{{'parkingBooking.freezerNotAllowed' | translate}}</h5>
    </div>
  </ng-container>
  <div *ngIf="bookingInfo">
    <h6 class="parking-name">{{bookingInfo.parkingName}}</h6>
    <p>{{bookingInfo.address}}</p>
    <div>
      {{'parkingBooking.form.date' | translate}}
      <strong>{{bookingInfo.startDate + ' - ' + bookingInfo.endDate}}</strong>
    </div>
    <div>
      {{'parkingBooking.form.totalAmount' | translate}}
      <strong>{{bookingInfo.totalAmount?.toFixed(2) + ' ' + bookingInfo.currency}}</strong>
    </div>
    <p>
      {{'parkingBooking.status.title' | translate}}:
      <strong>{{'parkingBooking.status.' + bookingInfo.status | translate}}</strong>
    </p>
    <div>
      {{'parkingBooking.form.reservationLink' | translate}}
      <strong><a [href]="bookingInfo.instructionsLink" target="_blank">{{bookingInfo.instructionsLink}}</a></strong>
    </div>
  </div>
</div>

<div *ngIf="bookingId != null && bookingInfo?.status === 'ACTIVE'" class="modal-footer">
  <button type="button"
          class="form__action--danger"
          role="button"
          *ngIf="bookingInfo.canCancel"
          (appOperationConfirm)="cancelBooking()">
    <i class="ico-trash"></i>
    {{'parkingBooking.actions.cancel' | translate}}
  </button>
  <div *ngIf="!bookingInfo.canCancel" class="modal-body">
    <h6><i class="ico-attention-triangle sz-m c-yellow"></i> {{'parkingBooking.travisNoCancel' | translate}}
      <a [href]="'https://www.yourtravis.com/truck-parking-regulations/'" target="_blank">TRAVIS Truck Parking Regulations</a>
    </h6>
  </div>
</div>

<div *ngIf="bookingId == null" class="modal-footer">
  <button type="button"
          class="form__action--secondary"
          role="button"
          [disabled]="!bookingForm?.valid
                      || (previousStart === bookingForm?.value.startDate && previousEnd === bookingForm?.value.endDate)"
          (click)="checkAvailability()">
    <i class="ico-search"></i>
    {{'parkingBooking.actions.availability' | translate}}
  </button>
  <button type="button"
          class="form__action--primary"
          role="button"
          [disabled]="!bookingForm?.valid || !parkingAvailable"
          (appOperationConfirm)="bookParking()">
    <i class="ico-check"></i>
    {{'parkingBooking.actions.confirm' | translate}}
  </button>
  <button type="button" class="form__action--tertiary" role="button" (click)="closeModal()">
    <i class="ico-close"></i>
    {{'button.cancel' | translate}}
  </button>
</div>
</ng-container>
